export const API_URL = 'API_URL';
export const BASE_URL = 'BASE_URL';
export const TRACKER_URL = 'TRACKER_URL';
export const AI_SERVICE_URL = 'AI_SERVICE_URL';
